import {
  ExtractFnReturnType,
  InfiniteQueryConfigType,
  useInfiniteQuery,
  UseInfiniteQueryResult,
} from "~/libs";

import { ApiClient } from "~/utils";

import {
  ApiManagersQuestionAnswerCategoriesIndexRequestType,
  ApiManagersQuestionAnswerCategoriesIndexResponseType,
} from "~/domains";

type RequestDataType = {
  params?: ApiManagersQuestionAnswerCategoriesIndexRequestType;
  page?: number;
};

const request = async ({
  params,
  page = 1,
}: RequestDataType): Promise<ApiManagersQuestionAnswerCategoriesIndexResponseType> => {
  const response =
    await new ApiClient().get<ApiManagersQuestionAnswerCategoriesIndexResponseType>(
      "/api/managers/question_answer_categories",
      { page, ...params },
    );
  return response.data;
};

type QueryFnType = typeof request;

type PropsType = {
  params?: ApiManagersQuestionAnswerCategoriesIndexRequestType;
  config?: InfiniteQueryConfigType<QueryFnType>;
};

export const useApisManagersQuestionAnswerCategoriesIndex = ({
  params,
  config = {},
}: PropsType = {}): UseInfiniteQueryResult<ApiManagersQuestionAnswerCategoriesIndexResponseType> => {
  return useInfiniteQuery<ExtractFnReturnType<QueryFnType>>(
    ["ApisManagersQuestionAnswerCategoriesIndex", params],
    ({ pageParam }) => {
      return request({ params, page: pageParam as number | undefined });
    },
    {
      ...config,
      getNextPageParam: (data) => {
        return data.pagy.hasMore ? data.pagy.currentPage + 1 : false;
      },
    },
  );
};
